import React from 'react'
import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import debug from 'debug'
import IntlMessages, { toParagraphs } from 'util/IntlMessages'
import LoginContainer from '../../containers/LoginContainer'

const loginDebug = debug('linkgua:login')

export class LoginForm extends React.Component {

  state = {
    step: 'enterAuthenticationInfo',
    email: '',
    emailValid: false
  }

  validateEmail = (email) => {
    if (!email) {
      loginDebug('validateEmail: undefined')
      return false
    }

    email = email.trim()

    loginDebug('validateEmail: email', email)

    if (email.length < 5) {
      loginDebug('validateEmail: email too short')
      return false
    }

    const atIndex = email.indexOf('@')
    if (atIndex < 1) {
      loginDebug('validateEmail: missing @')
      return false
    }

    const userPart = email.substr(0, atIndex).trim()
    loginDebug('validateEmail: userPart', userPart)

    if (userPart.length < 1) {
      loginDebug('validateEmail: user too short')
      return false
    }

    const domainPart = email.substr(atIndex + 1).trim()
    loginDebug('validateEmail: domainPart', domainPart)

    if (domainPart.length < 3) {
      loginDebug('validateEmail: domain too short')
      return false
    }

    const dotIndex = domainPart.indexOf('.')
    if (dotIndex < 1) {
      loginDebug('validateEmail: missing .')
      return false
    }

    const tldPart = domainPart.substr(dotIndex + 1).trim()
    loginDebug('validateEmail: tldPart', tldPart)

    if (tldPart.length < 1) {
      loginDebug('validateEmail: tld too short')
      return false
    }

    return true
  }

  handleEmailChange = (event) => {
    const email = event.target.value
    const emailValid = this.validateEmail(email)
    this.setState({ email, emailValid })
  }

  handleLogin = (event) => {
    event.preventDefault()
    loginDebug('handleSubmit', this.state)
    const { email, emailValid, step } = this.state
    if (emailValid && step === 'enterAuthenticationInfo') {
      this.props.onAuthenticationRequested(email, '/verifycode')
      this.setState({ step: 'waitingForAuthentication' })
    }
  }

  render () {
    const { email, emailValid, step } = this.state
    const {renderAs, headerLabelId: headerLabelIdFromProps } = this.props

    const stepTextLabelId = `component.loginForm.${step}Text`
    let stepText
    switch (step) {
      case 'enterAuthenticationInfo':
        stepText = (<IntlMessages id={stepTextLabelId} />)
        break
      case 'waitingForAuthentication':
        stepText = (<IntlMessages id={stepTextLabelId} values={{ email }}>{toParagraphs}</IntlMessages>)
        break
      default:
        loginDebug('missing handling of step', step)
        return null
    }

    const headerId = headerLabelIdFromProps ? headerLabelIdFromProps :`component.loginForm.${renderAs}Header`
    const actionLabelId = `component.loginForm.${renderAs}BtnLabel`
    const showInputForm = step === 'enterAuthenticationInfo'

    return (
      <LoginContainer headerLabelId={headerId}>
        <div>
          <div className="mb-4"><h4><span>{stepText}</span></h4></div>
          {showInputForm && (
            <div className="login-form">
              <form onSubmit={this.handleLogin}>
                <div className="form-group mb-3">
                  <input type="email" placeholder="Email"
                         className="form-control form-control-lg"
                         value={this.state.email}
                         onChange={this.handleEmailChange}
                  />
                </div>
                <div className="mb-3">
                  <Button disabled={!emailValid} onClick={this.handleLogin}>
                    <IntlMessages id={actionLabelId}/></Button>
                </div>
              </form>
            </div>
          )}
        </div>
      </LoginContainer>
    )
  }
}

LoginForm.propTypes = {
  onAuthenticationRequested: PropTypes.func.isRequired,
  renderAs: PropTypes.oneOf(['signUp', 'signIn']).isRequired,
  headerLabelId: PropTypes.string
}



// WEBPACK FOOTER //
// ./Linkgua/components/Login/index.js